import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ENV } from '@/common/app/env';
import { StringXSmall, TextXSmall } from '@/components/Typography/Typography';
import { Accordion } from '@/components/ui/Accordion/Accordion';

import { faqData } from './config';

import css from './styles.module.scss';

const PartnersFaq: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="px-2 flex flex-col gap-4 mb-6">
      {faqData.map(({ title, description, id }) => (
        <Accordion
          key={id}
          variant="bordered"
          classNames={{
            chevron: 'w-6 h-6',
          }}
          head={() => (
            <div className="w-full py-3 pl-4">
              <StringXSmall weight="bold">{t(title)}</StringXSmall>
            </div>
          )}
        >
          <div className={css.description}>
            <ul className={css.descriptionList}>
              {description.map((content, index) => (
                <li className={css.descriptionItem} key={`${id}-${index}`}>
                  <TextXSmall className="leading-[1.5] !text-white/80 inline-block">
                    {t(
                      content,
                      index === 1 ? { amount: ENV.MIN_USDT_TO_WITHDRAW } : {},
                    )}
                  </TextXSmall>
                </li>
              ))}
            </ul>
          </div>
        </Accordion>
      ))}
    </div>
  );
};

export { PartnersFaq };
